import { render, staticRenderFns } from "./TaxExpiry.vue?vue&type=template&id=38674374&"
import script from "./TaxExpiry.vue?vue&type=script&lang=js&"
export * from "./TaxExpiry.vue?vue&type=script&lang=js&"
import style0 from "./TaxExpiry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports